// extracted by mini-css-extract-plugin
export default {"notifications":"jz1xtbLcIMd3OuWqLzkw","icon":"BDTPyFnqLJFEvd9iBNKt","active":"wBRdkPrNNJ17NbSOtufq","badgeWrapper":"Iep3Ypf_4OKimk1T8VwQ","badge":"LtlNHlyov5rnP5UzSPeh"};